import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage";
import UserForm from "./components/UserForm";
import HeroSection from "./components/HeroSection";
import TimeTable from "./pages/TimeTable";
import RegisterPage from "./components/RegisterPage";
import LoginPage from "./components/LoginPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/users" element={<UserForm />} />
        <Route path="/" element={<HeroSection />} />
        <Route path="/timetable" element={<TimeTable />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
      </Routes>
    </Router>
  );
}

export default App;
